import React from "react";
import { Translate } from "react-localize-redux";
import "../../styles/components/_planDesc.scss";

const features = [
  { id: "f1", label: "content.planDesc1" },
  { id: "f2", label: "content.planDesc2" },
  { id: "f3", label: "content.planDesc3" },
  { id: "f4", label: "content.planDesc4" },
  { id: "f5", label: "content.planDesc5" },
  { id: "f6", label: "content.planDesc6" },
  { id: "f7", label: "content.planDesc7" },
];

const packagesData = [
  {
    id: "p-free",
    title: "Free",
    features: ["f1"],
  },
  {
    id: "p-premium",
    title: "Premium",
    features: ["f1", "f2", "f3", "f4", "f5", "f6", "f7"],
    highlight: true,
  },
];

export default function DescPlan() {
  return (
    <div className="plan-desc-container wow fadeInUp mt-0">
      <div className="pricing-box">
        <div className="table-wrapper">
          <table className="pricing-table">
            <thead>
              <tr>
                <th className="feature-col"></th>
                {packagesData.map((pkg) => (
                  <th key={pkg.id}>
                    <div className={pkg.highlight ? "package-title highlight" : "package-title"}>
                      {pkg.title}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {features.map((f) => (
                <tr key={f.id}>
                  <td className="features">
                    <Translate id={f.label} />
                  </td>
                  {packagesData.map((pkg) => {
                    const included = pkg.features.includes(f.id);
                    return (
                      <td key={pkg.id + f.id} className="icon-cell">
                        {included ? (
                          <img src="/correct.svg" alt="correct" />
                        ) : (
                          <img src="/cancel.svg" alt="cancel" />
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
